<script setup>
import { computed } from 'vue';

const props = defineProps({
  dark: {
    type: Boolean,
    default: false,
  },
});

const imagePath = computed(() => `/jlc/images/3d-model/${props.dark ? 'button-white' : 'button'}`);
</script>

<template>
  <picture>
    <img
      :src="`${imagePath}.gif`"
      alt="3D"
      class="lazyload lazyload--fade"
      :srcset="`${imagePath}@2x.gif 2x, ${imagePath}.gif 1x`"
    />
  </picture>
</template>
